import * as ambassadorWixCommentsCategoriesV1CommentsWidget from './comments-categories-v1-comments-widget-widgets.http.js';
import * as ambassadorWixCommentsCategoriesV1CommentsWidgetTypes from './comments-categories-v1-comments-widget-widgets.types.js';
import * as ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes from './comments-categories-v1-comments-widget-widgets.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function registerCommentsWidget(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.RegisterCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.RegisterCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.RegisterCommentsWidgetResponse,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.RegisterCommentsWidgetResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCommentsCategoriesV1CommentsWidget.registerCommentsWidget(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/comments/widgets/register',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCommentsWidgetResources(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.QueryCommentsWidgetResourcesRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.QueryCommentsWidgetResourcesRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.QueryCommentsWidgetResourcesResponse,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.QueryCommentsWidgetResourcesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCommentsCategoriesV1CommentsWidget.queryCommentsWidgetResources(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/comments/widgets/resources/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCommentsWidget(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.CreateCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.CreateCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.CreateCommentsWidgetResponse,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.CreateCommentsWidgetResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCommentsCategoriesV1CommentsWidget.createCommentsWidget(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/comments/widgets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCommentsWidget(): __PublicMethodMetaInfo<
  'GET',
  { commentsWidgetId: string },
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.GetCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.GetCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.GetCommentsWidgetResponse,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.GetCommentsWidgetResponse
> {
  const payload = { commentsWidgetId: ':commentsWidgetId' } as any;

  const getRequestOptions =
    ambassadorWixCommentsCategoriesV1CommentsWidget.getCommentsWidget(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/comments/widgets/{commentsWidgetId}',
    pathParams: { commentsWidgetId: 'commentsWidgetId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCommentsWidget(): __PublicMethodMetaInfo<
  'PATCH',
  { commentsWidgetId: string },
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.UpdateCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.UpdateCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.UpdateCommentsWidgetResponse,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.UpdateCommentsWidgetResponse
> {
  const payload = { commentsWidget: { id: ':commentsWidgetId' } } as any;

  const getRequestOptions =
    ambassadorWixCommentsCategoriesV1CommentsWidget.updateCommentsWidget(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/comments/widgets/{commentsWidget.id}',
    pathParams: { commentsWidgetId: 'commentsWidgetId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCommentsWidget(): __PublicMethodMetaInfo<
  'DELETE',
  { commentsWidgetId: string },
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.DeleteCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.DeleteCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.DeleteCommentsWidgetResponse,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.DeleteCommentsWidgetResponse
> {
  const payload = { commentsWidgetId: ':commentsWidgetId' } as any;

  const getRequestOptions =
    ambassadorWixCommentsCategoriesV1CommentsWidget.deleteCommentsWidget(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/comments/widgets/{commentsWidgetId}',
    pathParams: { commentsWidgetId: 'commentsWidgetId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCommentsWidget(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.QueryCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.QueryCommentsWidgetRequest,
  ambassadorWixCommentsCategoriesV1CommentsWidgetUniversalTypes.QueryCommentsWidgetResponse,
  ambassadorWixCommentsCategoriesV1CommentsWidgetTypes.QueryCommentsWidgetResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCommentsCategoriesV1CommentsWidget.queryCommentsWidget(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/comments/widgets/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CommentsWidget as CommentsWidgetOriginal,
  PageUrlV2 as PageUrlV2Original,
  RegisterCommentsWidgetRequest as RegisterCommentsWidgetRequestOriginal,
  RegisterCommentsWidgetResponse as RegisterCommentsWidgetResponseOriginal,
  QueryCommentsWidgetResourcesRequest as QueryCommentsWidgetResourcesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryCommentsWidgetResourcesResponse as QueryCommentsWidgetResourcesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  CreateCommentsWidgetRequest as CreateCommentsWidgetRequestOriginal,
  CreateCommentsWidgetResponse as CreateCommentsWidgetResponseOriginal,
  GetCommentsWidgetRequest as GetCommentsWidgetRequestOriginal,
  GetCommentsWidgetResponse as GetCommentsWidgetResponseOriginal,
  UpdateCommentsWidgetRequest as UpdateCommentsWidgetRequestOriginal,
  UpdateCommentsWidgetResponse as UpdateCommentsWidgetResponseOriginal,
  DeleteCommentsWidgetRequest as DeleteCommentsWidgetRequestOriginal,
  DeleteCommentsWidgetResponse as DeleteCommentsWidgetResponseOriginal,
  QueryCommentsWidgetRequest as QueryCommentsWidgetRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Paging as PagingOriginal,
  QueryCommentsWidgetResponse as QueryCommentsWidgetResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './comments-categories-v1-comments-widget-widgets.types.js';
